import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import propertyCountActions from '../actions/propertyCount';

// Middleware function
function getListingMetadata(store) {
    request.get(`/${config.url_prefix}/api/getListingsCount?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(propertyCountActions.alertError('ipmob.internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (parsedResponse) {
                        store.dispatch(propertyCountActions.getListingMetadataSuccess(parsedResponse));
                    } else {
                        store.dispatch(propertyCountActions.alertError('ipmob.error.process.request'));
                    }
                } catch (exp) {
                    store.dispatch(propertyCountActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getListingMetadata;
